import { isAiDiscoveryLive, isFeatureFlagMaybe } from "@/domain/user"
import { useFeatureFlags } from "@/hooks/useUser"
import { Loader } from "@/molecules/Loader"
import { AiComponentsTab } from "./AiComponentsTab"
import { LiveAiComponentsTab } from "./LiveAiComponentsTab"

import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"
import type { AiComponentsEntityType } from "./AiComponentsTabAgentAiDiscoveryDrawer.types"

export const AiComponentsTabAgentAiDiscoveryDrawer = (
  props: TabComponentProps & { entityType?: AiComponentsEntityType }
) => {
  const { entityType = "agent", ...tabProps } = props
  const aiDiscovery = useFeatureFlags("aiDiscovery")

  if (isFeatureFlagMaybe(aiDiscovery)) return <Loader />

  // Only an agent's live tab adds its MCP servers and knowledge sources
  return entityType === "agent" && isAiDiscoveryLive(aiDiscovery) ? (
    <LiveAiComponentsTab {...tabProps} />
  ) : (
    <AiComponentsTab {...tabProps} entityType={entityType} />
  )
}
